import React, { useState } from "react";
import close1 from "../../../assets/images/model/close.svg";
import author from "../../../assets/images/model/author.png";
import { TagsInput } from "react-tag-input-component";
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const UploadBookLoading = ({
  setUploadBook,
  chosenFile,
  linkToFile,
  formValues,
  setFormValues,
  setGotoConfrimAuthor,
  setUploadLoadingBook,
  uploadLoading,
}) => {
  const [materialType, setMaterialType] = useState(false);
  const [err, setErr] = useState("");

  const [categoryType, setCategoryType] = useState(false);

  const MaterialTypeToogle = () => {
    setMaterialType(!materialType);
  };
  const CategoryTypeToogle = () => {
    setCategoryType(!categoryType);
  };
  const handleSelectMaterial = (selectedItem) => {
    setErr("");
    setFormValues((old) => ({ ...old, materialType: selectedItem }));
    setMaterialType(false); // Close the dropdown after selecting
  };
  const handleSelectCategory = (selectedItem) => {
    setErr("");
    setFormValues((old) => ({ ...old, categoryType: selectedItem }));
    setCategoryType(false); // Close the dropdown after selecting
  };
  const handleChange = (e) => {
    setErr("");
    const { name, value } = e.target;
    setFormValues((old) => ({ ...old, [name]: value }));
  };
  /* Tags */
  const [inputValue, setInputValue] = useState("");
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleAddTag = () => {
    if (inputValue.trim() !== "" && formValues.subjects.length < 3) {
      setFormValues((old) => {
        return { ...old, subjects: [...old.subjects, inputValue.trim()] };
      });
      setInputValue("");
    }
  };
  return (
    <div
      className="modal custom_background custom_modal_create"
      id="while_your_book_loads"
      style={{ display: "block" }}
      tabIndex="-1"
      aria-labelledby="while_your_book_loadsLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              /*  onClick={() => {
                setUploadBook(false);
                setSelectOption(true);
              }} */
              onClick={() => {
                setUploadLoadingBook(false);
                setUploadBook(false);
              }}
            >
              <img src={close1} alt="close" />
            </button>
          </div>
          <div className="modal-body-cre">
            <h4>while your book loads...</h4>
            <p>
              Fill out basic information and invite other authors to help. You
              can always change or add to this information later in
              greyledteach.
            </p>
            <form
              action=""
              className="while_your_book_loads"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className="while_your_book_loads_filter my-40">
                <div className="form-group mb-45">
                  <input
                    type="text"
                    name="title"
                    value={formValues.title}
                    onChange={handleChange}
                    className="form-control pl_0"
                    placeholder="Title"
                  />
                  <span className="error-create" style={{ display: "none" }}>
                    please select title
                  </span>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group mb-45">
                      <div className="select_wrap_create">
                        <p
                          className={`cursor_pointer form-control pl_0 custom_select_create text-grey ${
                            materialType ? "open" : ""
                          }`}
                          onClick={MaterialTypeToogle}
                        >
                          {formValues.materialType || "Material type"}
                        </p>
                        {materialType && (
                          <div
                            className="drop_down_list_create"
                            style={{ display: "block" }}
                          >
                            <ul>
                              <li
                                onClick={() => handleSelectMaterial("Textbook")}
                              >
                                Textbook
                              </li>
                              <li
                                onClick={() =>
                                  handleSelectMaterial("Research Article")
                                }
                              >
                                Research Article
                              </li>
                              <li
                                onClick={() =>
                                  handleSelectMaterial("Media Article")
                                }
                              >
                                Media Article
                              </li>
                              <li onClick={() => handleSelectMaterial("Other")}>
                                Other
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                      <span
                        className="error-create"
                        style={{ display: "none" }}
                      >
                        please select title
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-45">
                      <div className="select_wrap_create">
                        <p
                          className={`cursor_pointer form-control pl_0 custom_select_create text-grey ${
                            categoryType ? "open" : ""
                          }`}
                          onClick={CategoryTypeToogle}
                        >
                          {formValues.categoryType || "Category"}
                        </p>
                        {categoryType && (
                          <div className="drop_down_list_create">
                            <ul>
                              <li onClick={() => handleSelectCategory("Arts")}>
                                Arts
                              </li>
                              <li
                                onClick={() => handleSelectCategory("Business")}
                              >
                                Business
                              </li>
                              <li
                                onClick={() =>
                                  handleSelectCategory("Education")
                                }
                              >
                                Education
                              </li>
                              <li
                                onClick={() =>
                                  handleSelectCategory("Engineering")
                                }
                              >
                                Engineering
                              </li>
                              <li
                                onClick={() =>
                                  handleSelectCategory("Healthcare")
                                }
                              >
                                Healthcare
                              </li>
                              <li
                                onClick={() =>
                                  handleSelectCategory("Humanities")
                                }
                              >
                                Humanities
                              </li>
                              <li
                                onClick={() =>
                                  handleSelectCategory(
                                    "Journalism, Media Studies.."
                                  )
                                }
                              >
                                Journalism, Media Studies & Communications
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                      <span
                        className="error-create"
                        style={{ display: "none" }}
                      >
                        please select title
                      </span>
                    </div>
                  </div>
                </div>
                <div className="form-group mb-45">
                  <div className="add_value_wrap-create">
                    <div className="add_vlue_input_tage">
                      <TagsInput
                        value={formValues.subjects}
                        onChange={(val) => {
                          setFormValues((old) => {
                            return { ...old, subjects: val };
                          });
                        }}
                        onExisting={() => {
                          return false;
                        }}
                        name="fruits"
                        placeHolder="Subject tags (add one at a time)"
                        className="form-control pl_0"
                        autoComplete="off"
                        inputValue={inputValue}
                        onChangeInput={handleInputChange}
                      />
                      <span className="add_tages">
                        {formValues.subjects.length}/3
                      </span>
                    </div>
                    <button
                      type="button"
                      className="add_btn_value_create"
                      onClick={handleAddTag}
                      disabled={formValues.subjects.length >= 3} // Disable button when the tag count reaches 3
                    >
                      Add
                    </button>
                  </div>
                  <span className="error-create" style={{ display: "none" }}>
                    please enter email
                  </span>
                </div>
                <div className="form-group mb-45">
                  <div className="author_fname">
                    <div className="author_f_img">
                      <img src={author} alt="author" />
                    </div>
                    <div className="checkbox-wrapper-create">
                      <input
                        id="cbx-42"
                        type="checkbox"
                        checked={formValues.isImAuthor}
                        onChange={(e) => {
                          setFormValues((old) => ({
                            ...old,
                            isImAuthor: e.target.checked,
                          }));
                        }}
                      />
                      <label className="cbx" htmlFor="cbx-42"></label>
                      <label className="lbl" htmlFor="cbx-42">
                        I am the author
                      </label>
                    </div>
                  </div>
                  <input
                    type="email"
                    value={formValues.originalAuthor}
                    name="originalAuthor"
                    onChange={handleChange}
                    className="form-control pl_0"
                    placeholder="Add the original author(s) by email"
                  />
                  <span className="error-create" style={{ display: "none" }}>
                    please enter email
                  </span>
                </div>
                <div className="form-group mb-45">
                  <input
                    type="email"
                    value={formValues.collaborator}
                    name="collaborator"
                    onChange={handleChange}
                    className="form-control pl_0"
                    placeholder="Invite a collaborator by email"
                  />
                  <span className="error-create" style={{ display: "none" }}>
                    please enter email
                  </span>
                </div>
              </div>
              {err && (
                <div
                  style={{
                    color: "red",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {err}
                </div>
              )}
              <div className="modal-btn">
                <button
                  type="button"
                  className="btn-black_create mb-24"
                  onClick={() => {
                    if (!formValues.categoryType) {
                      setErr("Category is required.");
                      return;
                    }
                    if (!formValues.materialType) {
                      setErr("Material type is required.");
                      return;
                    }
                    if (!formValues.isImAuthor && !formValues.originalAuthor) {
                      setErr("Please provide an author.");
                      return;
                    }
                    if (
                      formValues.collaborator &&
                      !emailRegex.test(formValues.collaborator)
                    ) {
                      setErr("Collaborator must be a valid email address.");
                      return;
                    }
                    if (
                      !formValues.isImAuthor &&
                      formValues.originalAuthor &&
                      !emailRegex.test(formValues.originalAuthor)
                    ) {
                      setErr("Original author must be a valid email address.");
                      return;
                    }
                    setGotoConfrimAuthor(true);
                    setUploadLoadingBook(false);
                  }}
                >
                  Next
                </button>
                <button
                  type="button"
                  className="btn-white-create"
                  onClick={() => {
                    setUploadLoadingBook(false);
                    setUploadBook(true);
                  }}
                >
                  Go back
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadBookLoading;
